import type { ResearchVariant } from "../api/research";
import { fmtKst, fmtNumber } from "../lib/format";
import { EmptyState } from "./ui/Primitives";

export default function ResearchEquityChart({ variant }: { variant: ResearchVariant }) {
  const points = variant.path;
  if (!points.length) return <EmptyState title="새 관찰 기록을 기다리고 있습니다" description="첫 평가 자산 기록이 생기면 순자산 곡선을 표시합니다." />;
  const values = points.flatMap(p => [p.baseline, p.cost2x, 1]);
  const low = Math.min(...values), high = Math.max(...values);
  const pad = Math.max((high - low) * .12, .002);
  const y = (v: number) => 155 - (v - low + pad) / (high - low + pad * 2) * 130;
  const times = points.map(p => Date.parse(p.at));
  const x = (i: number) => points.length === 1 ? 300 : 45 + (times[i] - times[0]) / Math.max(1, times[times.length - 1] - times[0]) * 500;
  return <figure className="research-chart"><svg viewBox="0 0 600 195" role="img" aria-label={`${variant.title} 관찰 순자산 곡선. 기준 비용과 두 배 비용 비교`}>
    <title>{variant.title} · 최초 순자산 1.000</title>
    <line x1="45" x2="545" y1={y(1)} y2={y(1)} className="chart-reference" />
    <text x="5" y={y(1) + 4}>1.000</text>
    {(["baseline", "cost2x"] as const).map(key => <g key={key} className={`chart-${key}`}>
      <polyline points={points.map((p, i) => `${x(i)},${y(p[key])}`).join(" ")} fill="none" />
      {points.map((p, i) => <circle key={p.at} cx={x(i)} cy={y(p[key])} r="3" tabIndex={0}><title>{fmtKst(p.at)} · {key === "baseline" ? "기준 비용" : "비용 2배"} {fmtNumber(p[key], { digits: 4 })}</title></circle>)}
    </g>)}
    <text x="45" y="185">{fmtKst(points[0].at, { seconds: false })}</text><text x="545" y="185" textAnchor="end">{fmtKst(points[points.length - 1].at, { seconds: false })}</text>
  </svg><figcaption><span className="chart-key-baseline">기준 비용</span><span className="chart-key-cost2x">비용 2배</span><span>일별 마지막 실제 관찰 · KST</span></figcaption></figure>;
}
